import React from 'react';

import { Color } from 'modules/styles/colors';

export const styles = {
  fill: 'none',
  stroke: Color.black,
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeMiterlimit: 10
} as const;

export default {
  svg: (
    <g>
      <g>
        <path
          style={{ fill: Color.black }}
          d="M11.6,13.9L7.4,9.6c-0.9-0.9-0.9-2.4,0-3.3c0.9-0.9,2.4-0.9,3.3,0l0.9,0.9l0.9-0.9c0.9-0.9,2.4-0.9,3.3,0
			c0.9,0.9,0.9,2.4,0,3.3L11.6,13.9z"
        />
        <polygon {...styles} points="11.7,0.5 1.9,0.5 1.9,23.1 11.7,18.7 22.1,23.1 22.1,0.5 " />
      </g>
    </g>
  ),
  viewBox: '0 0 30 30'
};
